var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterBtnIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.455,
    height: 13.216,
    viewBox: "0 0 16.455 13.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11463",
    "data-name": "Group 11463",
    transform: "translate(-675.778 -49.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29642",
    "data-name": "Path 29642",
    d: "M1157.15-90h10.53",
    transform: "translate(-481.373 142.102)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29647",
    "data-name": "Path 29647",
    d: "M1167.681-90h-10.53",
    transform: "translate(-475.448 146.466)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29651",
    "data-name": "Path 29651",
    d: "M1167.681-90h-10.53",
    transform: "translate(-475.448 150.83)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29643",
    "data-name": "Path 29643",
    d: "M1168.385-90h3.107",
    transform: "translate(-480.35 142.102)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29649",
    "data-name": "Path 29649",
    d: "M1168.385-90h3.107",
    transform: "translate(-492.351 150.83)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29645",
    "data-name": "Path 29645",
    d: "M1171.492-90h-3.107",
    transform: "translate(-491.516 146.466)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29644",
    "data-name": "Path 29644",
    d: "M1171.233-92.249v4.488",
    transform: "translate(-480.091 141.898)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29650",
    "data-name": "Path 29650",
    d: "M1171.233-92.249v4.488",
    transform: "translate(-489.91 150.626)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29646",
    "data-name": "Path 29646",
    d: "M1171.233-92.249v4.488",
    transform: "translate(-494.364 146.262)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBtnIcon);
export default __webpack_public_path__ + "static/media/FilterBtnIcon.99cc49c8ee130d88c7d07098e51754cd.svg";
export { ForwardRef as ReactComponent };